export default __webpack_public_path__ + "static/media/scrumwise.c38be63f.svg";